<template>
    <f7-page no-navbar no-toolbar class="login-page">
        <f7-page-content class="login-page-content">
            <!-- Background Image & Overlay -->
            <div class="login-bg-image"></div>
            <div class="backdrop-overlay"></div>
            
            <!-- Login Container -->
            <div class="login-container">
                <div class="login-card">
                    <!-- Logo & Brand Header -->
                    <div class="brand-header">
                        <img class="brand-logo" src="./../assets/images/logo_eic.png" alt="EIC Logo" />
                        <h1 class="brand-title">HỆ THỐNG THI TRỰC TUYẾN</h1>
                        <p class="brand-subtitle">Đăng nhập tài khoản để làm bài kiểm tra</p>
                    </div>

                    <!-- Login Form -->
                    <form class="login-form" @submit.prevent="loginUser(username, password)">
                        <!-- Username Field -->
                        <div class="form-group">
                            <label class="form-label" for="login-username">Tên tài khoản</label>
                            <div class="input-wrapper">
                                <span class="input-icon">
                                    <i class="fa fa-user" aria-hidden="true"></i>
                                </span>
                                <input
                                    id="login-username"
                                    type="text"
                                    class="custom-input"
                                    v-model="username"
                                    placeholder="Nhập tên tài khoản"
                                    autocomplete="username"
                                    autocorrect="off"
                                    autocapitalize="off" />
                            </div>
                        </div>

                        <!-- Password Field -->
                        <div class="form-group">
                            <label class="form-label" for="login-password">Mật khẩu</label>
                            <div class="input-wrapper">
                                <span class="input-icon">
                                    <i class="fa fa-lock" aria-hidden="true"></i>
                                </span>
                                <input
                                    id="login-password"
                                    :type="showPassword ? 'text' : 'password'"
                                    class="custom-input"
                                    v-model="password"
                                    placeholder="Nhập mật khẩu"
                                    autocomplete="current-password" />
                                <button
                                    type="button"
                                    class="toggle-password-btn"
                                    @click="showPassword = !showPassword"
                                    tabindex="-1"
                                    aria-label="Ẩn / hiện mật khẩu">
                                    <i :class="showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'" aria-hidden="true"></i>
                                </button>
                            </div>
                        </div>

                        <!-- Submit Button -->
                        <button
                            type="submit"
                            class="btn-login-submit"
                            :disabled="isLoading">
                            <span v-if="!isLoading">ĐĂNG NHẬP</span>
                            <span v-else class="loading-state">
                                <span class="preloader-spinner"></span> Đang đăng nhập...
                            </span>
                        </button>
                    </form>

                    <!-- Footer Info -->
                    <div class="login-footer">
                        <span class="version-badge">Version 1.0.9</span>
                        <div class="copyright-text">&copy; 2026 EIC Corporation. All rights reserved.</div>
                    </div>
                </div>
            </div>
        </f7-page-content>
    </f7-page>
</template>

<style scoped>
.login-page {
    background: #0f172a;
}

.login-page-content {
    padding: 20px 16px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    min-height: 100vh !important;
    box-sizing: border-box !important;
    position: relative;
    overflow-y: auto !important;
}

.login-bg-image {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: url("./../assets/images/bg-dang-nhap.jpg");
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
    z-index: 1;
    pointer-events: none;
}

.backdrop-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(145deg, rgba(15, 23, 42, 0.78) 0%, rgba(9, 58, 165, 0.65) 50%, rgba(15, 23, 42, 0.85) 100%);
    backdrop-filter: blur(4px);
    -webkit-backdrop-filter: blur(4px);
    z-index: 2;
    pointer-events: none;
}

.login-container {
    position: relative;
    z-index: 10;
    width: 100%;
    max-width: 420px;
    margin: auto;
    pointer-events: auto;
}

.login-card {
    background: rgba(255, 255, 255, 0.96);
    border-radius: 20px;
    padding: 36px 28px 24px 28px;
    box-shadow: 0 20px 40px -10px rgba(0, 0, 0, 0.35), 0 0 0 1px rgba(255, 255, 255, 0.3);
    box-sizing: border-box;
    pointer-events: auto;
}

.brand-header {
    text-align: center;
    margin-bottom: 26px;
}

.brand-logo {
    max-width: 175px;
    height: auto;
    display: inline-block;
    margin-bottom: 12px;
}

.brand-title {
    margin: 0;
    font-size: 17px;
    font-weight: 800;
    color: #0f2b5c;
    letter-spacing: 0.5px;
    text-transform: uppercase;
}

.brand-subtitle {
    margin: 6px 0 0 0;
    font-size: 13px;
    color: #64748b;
}

.login-form {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.form-group {
    display: flex;
    flex-direction: column;
}

.form-label {
    font-size: 13px;
    font-weight: 600;
    color: #334155;
    margin-bottom: 6px;
}

.input-wrapper {
    display: flex !important;
    flex-direction: row !important;
    align-items: center !important;
    background: #f8fafc !important;
    border: 1.5px solid #cbd5e1 !important;
    border-radius: 10px !important;
    height: 48px !important;
    padding: 0 14px !important;
    box-sizing: border-box !important;
    width: 100% !important;
    transition: all 0.2s ease;
}

.input-wrapper:focus-within {
    background: #ffffff !important;
    border-color: #e0613d !important;
    box-shadow: 0 0 0 3px rgba(224, 97, 61, 0.15) !important;
}

.input-icon {
    color: #94a3b8 !important;
    font-size: 16px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    margin-right: 12px !important;
    flex-shrink: 0 !important;
    width: 18px !important;
    pointer-events: none !important;
}

.input-wrapper:focus-within .input-icon {
    color: #e0613d !important;
}

.custom-input {
    flex: 1 1 auto !important;
    width: 100% !important;
    height: 44px !important;
    line-height: normal !important;
    border: none !important;
    outline: none !important;
    background: transparent !important;
    color: #0f172a !important;
    font-size: 15px !important;
    font-family: inherit !important;
    padding: 0 !important;
    margin: 0 !important;
    box-shadow: none !important;
    -webkit-appearance: none !important;
    -moz-appearance: none !important;
    appearance: none !important;
    display: block !important;
    box-sizing: border-box !important;
    pointer-events: auto !important;
    -webkit-user-select: text !important;
    user-select: text !important;
}

.custom-input::placeholder {
    color: #94a3b8 !important;
    font-size: 14px !important;
}

.toggle-password-btn {
    background: transparent !important;
    border: none !important;
    outline: none !important;
    padding: 0 !important;
    margin-left: 8px !important;
    color: #94a3b8 !important;
    cursor: pointer !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    font-size: 16px !important;
    width: 24px !important;
    height: 24px !important;
    flex-shrink: 0 !important;
    transition: color 0.2s ease;
    box-shadow: none !important;
    -webkit-tap-highlight-color: transparent;
}

.toggle-password-btn:hover {
    color: #475569 !important;
}

.input-wrapper:focus-within .toggle-password-btn {
    color: #64748b !important;
}

.input-wrapper:focus-within .toggle-password-btn:hover {
    color: #e0613d !important;
}

.btn-login-submit {
    margin-top: 8px;
    height: 46px;
    background: linear-gradient(135deg, #e0613d 0%, #c94e2b 100%);
    color: #ffffff;
    border: none;
    border-radius: 10px;
    font-size: 15px;
    font-weight: 700;
    letter-spacing: 0.8px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 14px rgba(224, 97, 61, 0.35);
    transition: all 0.2s ease;
    width: 100%;
}

.btn-login-submit:hover:not(:disabled) {
    background: linear-gradient(135deg, #d35532 0%, #b84323 100%);
    box-shadow: 0 6px 18px rgba(224, 97, 61, 0.45);
    transform: translateY(-1px);
}

.btn-login-submit:active:not(:disabled) {
    transform: translateY(0);
    box-shadow: 0 2px 8px rgba(224, 97, 61, 0.3);
}

.btn-login-submit:disabled {
    opacity: 0.7;
    cursor: not-allowed;
}

.loading-state {
    display: flex;
    align-items: center;
    gap: 8px;
}

.preloader-spinner {
    width: 16px;
    height: 16px;
    border: 2px solid rgba(255, 255, 255, 0.3);
    border-top-color: #ffffff;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
    display: inline-block;
}

@keyframes spin {
    to { transform: rotate(360deg); }
}

.login-footer {
    margin-top: 24px;
    text-align: center;
    border-top: 1px solid #f1f5f9;
    padding-top: 16px;
}

.version-badge {
    display: inline-block;
    background: #f1f5f9;
    color: #64748b;
    font-size: 11px;
    font-weight: 600;
    padding: 3px 10px;
    border-radius: 12px;
    letter-spacing: 0.3px;
    margin-bottom: 8px;
}

.copyright-text {
    font-size: 11px;
    color: #94a3b8;
}

@media (max-width: 480px) {
    .login-card {
        padding: 28px 20px 20px 20px;
        border-radius: 16px;
    }

    .brand-title {
        font-size: 16px;
    }

    .custom-input {
        font-size: 14px !important;
    }

    .btn-login-submit {
        height: 44px;
        font-size: 14px;
    }
}
</style>

<script>
import { Roles } from "./../../global.js";
import TrangThai from "./../../common.js";
import apiEndPoint from "./../../apiEndpoint.js";
import { EventLogin } from "../event-login.js";
import axios from "axios";

export default {
    data() {
        return {
            username: "",
            password: "",
            showPassword: false,
            userInfo: null,
            isLoading: false
        };
    },
    methods: {
        async checkPhoneExist(phoneNumber) {
            let isPhoneExist = false;
            let url = apiEndPoint + "api/AppUsers/count";
            let res = await axios.get(url, {
                params: {
                    where: {
                        username: phoneNumber
                    }
                }
            });
            let count = res.data.count;
            return count > 0;
        },
        openAlert(titlename) {
            const app = this.$f7;
            app.dialog.alert("" + titlename, "Thông báo", () => {});
        },
        setAxiosGlobal(token) {
            axios.defaults.headers = { Authorization: token };
        },
        async loginUser(username, password) {
            if (!username || !password) {
                this.openAlert("Vui lòng điền đầy đủ tên tài khoản và mật khẩu!");
                return;
            }
            
            this.isLoading = true;
            let url = apiEndPoint + "api/AppUsers/login";
            let item = {
                username: username.trim(),
                password: password
            };
            
            try {
                let res = await axios.post(url, item);
                if (res.data.userId !== undefined && res.data.userId > 0) {
                    this.setAxiosGlobal(res.data.id);
                    await this.getDSPhongBan();
                    let userData = await axios.get(apiEndPoint + "api/AppUsers/" + res.data.userId);
                    
                    if (!userData.data.isActive) {
                        this.openAlert("Tài khoản của bạn hiện đang bị khóa hoặc chưa kích hoạt!");
                        this.isLoading = false;
                        return;
                    } else {
                        localStorage.setItem(
                            "eic_quiz_userInfo",
                            JSON.stringify({
                                ten: userData.data.ten,
                                chucVu: userData.data.chucVu,
                                userId: userData.data.id,
                                userName: userData.data.username,
                                phongBanId: userData.data.phongBanId,
                                dsphongBanId: userData.data.phongBanQuanLyId,
                                roleId: userData.data.roleId,
                                isActive: userData.data.isActive || false,
                                email: userData.data.email
                            })
                        );
                        localStorage.setItem("eic_quiz_tokenKey", res.data.id);
                        localStorage.setItem(
                            "eic_quiz_dateExpireToken",
                            new Date(new Date().getTime() + 7 * 24 * 60 * 60 * 1000).toISOString()
                        );
                        EventLogin.$emit("userLoggedIn", this.$userInfoGlobal);
                        this.$f7router.navigate("/list-quiz/");
                    }
                } else {
                    this.openAlert("Đăng nhập không thành công, vui lòng kiểm tra lại!");
                }
            } catch (error) {
                console.log(error);
                this.openAlert("Tên tài khoản hoặc mật khẩu không chính xác!");
            } finally {
                this.isLoading = false;
            }
        },
        async getDSPhongBan() {
            let url = apiEndPoint + "api/PhongBans";
            let filter = {
                fields: {
                    id: true,
                    ten: true,
                    ma: true,
                    boPhan: true
                },
                where: {}
            };
            try {
                let res = await axios.get(url, {
                    params: {
                        filter: filter
                    }
                });
                this.dsPhongBan = res.data;
                localStorage.setItem("eic_quiz_dsPhongBan", JSON.stringify(this.dsPhongBan));
            } catch (error) {
                console.log(error);
            }
        }
    },
    async created() {
        let userData = JSON.parse(localStorage.getItem("eic_quiz_userInfo"));
        let dateExpireToken = new Date(localStorage.getItem("eic_quiz_dateExpireToken"));
        if (dateExpireToken && dateExpireToken < new Date()) {
            return;
        }
        if (userData) {
            setTimeout(() => this.$f7router.navigate("/list-quiz/"), 0);
        }
    }
};
</script>
